import React from 'react';
import { useNavigate } from 'react-router-dom';

interface LegalLayoutProps {
  children: React.ReactNode;
}

const LegalLayout: React.FC<LegalLayoutProps> = ({ children }) => {
  const navigate = useNavigate();

  return (
    <div style={{ backgroundColor: '#fff', minHeight: '100vh', color: '#2a2a33' }}>
      <nav style={{ padding: '20px 40px', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {/* Navigate to root */}
        <div 
          onClick={() => navigate('/')} 
          style={{ cursor: 'pointer', fontWeight: 800, fontSize: '24px', color: '#000' }}
        >
          Resitus<span style={{ color: '#4dabf7' }}>.</span>
        </div>
        <div onClick={() => navigate('/')} style={{ cursor: 'pointer', color: '#64748b', fontSize: '14px', fontWeight: 600 }}>
          Return to Home
        </div>
      </nav>
      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '60px 24px' }}>
        {children}
      </div>
    </div>
  );
};

export default LegalLayout;